import { render } from "./MarketplacesTechnology.vue?vue&type=template&id=06d1cc2c"
import script from "./MarketplacesTechnology.vue?vue&type=script&lang=ts"
export * from "./MarketplacesTechnology.vue?vue&type=script&lang=ts"

import "./MarketplacesTechnology.vue?vue&type=style&index=0&id=06d1cc2c&lang=scss"
script.render = render

export default script